/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strategy_Partner_Us_Ai_TitleInputs */

const en_strategy_partner_us_ai_title = /** @type {(inputs: Strategy_Partner_Us_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise AI Leaders ATP`)
};

const de_strategy_partner_us_ai_title = /** @type {(inputs: Strategy_Partner_Us_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise US AI Leaders-Strategie`)
};

const pt_br2_strategy_partner_us_ai_title = /** @type {(inputs: Strategy_Partner_Us_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estratégia Bitwise de Líderes em IA dos EUA`)
};

const tr_strategy_partner_us_ai_title = /** @type {(inputs: Strategy_Partner_Us_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise ABD Yapay Zekâ Liderleri Stratejisi`)
};

const zh_cn2_strategy_partner_us_ai_title = /** @type {(inputs: Strategy_Partner_Us_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise 美国 AI 领军企业策略`)
};

const zh_hk2_strategy_partner_us_ai_title = /** @type {(inputs: Strategy_Partner_Us_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise 美國 AI 領先企業策略`)
};

const ko_kr2_strategy_partner_us_ai_title = /** @type {(inputs: Strategy_Partner_Us_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise 미국 AI 리더 전략`)
};

const ru_ru2_strategy_partner_us_ai_title = /** @type {(inputs: Strategy_Partner_Us_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стратегия Bitwise US AI Leaders`)
};

const es_419_strategy_partner_us_ai_title = /** @type {(inputs: Strategy_Partner_Us_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrategia Bitwise de Líderes en IA de EE. UU.`)
};

/**
* | output |
* | --- |
* | "Bitwise AI Leaders ATP" |
*
* @param {Strategy_Partner_Us_Ai_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const strategy_partner_us_ai_title = /** @type {((inputs?: Strategy_Partner_Us_Ai_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strategy_Partner_Us_Ai_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_strategy_partner_us_ai_title(inputs)
	if (locale === "de") return de_strategy_partner_us_ai_title(inputs)
	if (locale === "pt-BR") return pt_br2_strategy_partner_us_ai_title(inputs)
	if (locale === "tr") return tr_strategy_partner_us_ai_title(inputs)
	if (locale === "zh-CN") return zh_cn2_strategy_partner_us_ai_title(inputs)
	if (locale === "zh-HK") return zh_hk2_strategy_partner_us_ai_title(inputs)
	if (locale === "ko-KR") return ko_kr2_strategy_partner_us_ai_title(inputs)
	if (locale === "ru-RU") return ru_ru2_strategy_partner_us_ai_title(inputs)
	return es_419_strategy_partner_us_ai_title(inputs)
});